<template lang="html">
  <article class="media">
    <figure class="media-left">
      <p class="image is-64x64">
        <img src="http://res.cloudinary.com/digitalbits/image/upload/v1505289566/euromeal/logo-icon.svg">
      </p>
    </figure>
    <slot/>
    <!--<div class="media-content">

      nav class="level is-mobile">
        <div class="level-left">
          <a class="level-item">
            <span class="icon is-small"><i class="fa fa-reply"></i></span>
          </a>
          <a class="level-item">
            <span class="icon is-small"><i class="fa fa-retweet"></i></span>
          </a>
          <a class="level-item">
            <span class="icon is-small"><i class="fa fa-heart"></i></span>
          </a>
        </div>
      </nav>
    </div>-->
    <!--<div class="media-right">
      <button class="delete"></button>
    </div>-->
  </article>
</template>

<script>
export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/comment/Comment.vue